import React, { useState, useEffect } from 'react';
import { MultiSelect } from "react-multi-select-component";

import './orgHierarchyFilter.scss';

interface OrgHierarchyFilterProps {
  options: Array<{
    label: string,
    value: number | number[],
  }>;
  selectedOrgs: Array<{
    label: string,
    value: number | number[],
  }>
  handleChange: (drivers) => void;
  className?: string;
}

const OrgHierarchyFilter = (props: OrgHierarchyFilterProps) => {
  const {
    options,
    selectedOrgs,
    handleChange,
    className,
  } = props;


  const [selected, setSelected] = useState(selectedOrgs);

  const msg = `* If no organization are selected, all will be shown.`

  useEffect(() => {
    setSelected(selectedOrgs);
  }, [selectedOrgs]);

  const onChange = (newValue) => {
    setSelected(newValue);
    handleChange(newValue);
  };

  return (
    <div className={`d-flex align-items-center flex-column org-hierarchy-filter ${className}`}>
      <MultiSelect
        options={options}
        value={selected}
        hasSelectAll
        onChange={onChange}
        labelledBy="Select"
      />
      <div className="orgs-select-msg">{msg}</div>
    </div>
  );
};

OrgHierarchyFilter.defaultProps = {
  className: ''
};

export default OrgHierarchyFilter;
